import { useContext } from 'react';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import OnHoldTooltip from './OnHoldTooltip';

export default function OnHoldBadge() {
  const { timeLeftAsShortString } = useContext(UnlockTimerContext);

  return (
    <div className="flex gap-sm">
      <OnHoldTooltip />
      <span>{timeLeftAsShortString}</span>
    </div>
  );
}
